// Time-related field names (kept as fallback reference)
export const TIME_FIELDS = new Set(['year', 'month', 'quarter', 'date', 'week', 'day', 'period', 'effective_year', 'effective_month', 'policy_year', 'accident_year', 'calendar_year']);

/**
 * Pivot data for chart rendering based on AI-directed color_by field.
 * Only pivots when the AI explicitly specifies a color_by dimension.
 */
export function pivotForChart(rawData, dimensions, measures, xAxis, colorBy) {
  if (!rawData?.length || !colorBy || measures.length < 1) return null;
  const xDim = xAxis || dimensions.find(d => d !== colorBy) || dimensions[0];
  const seriesDim = colorBy;
  const measure = measures[0];
  if (!xDim || xDim === seriesDim) return null;
  const xVals = [...new Set(rawData.map(r => r[xDim]))];
  const seriesVals = [...new Set(rawData.map(r => r[seriesDim]))];
  const pivoted = xVals.map(xVal => {
    const row = { [xDim]: xVal };
    seriesVals.forEach(sv => {
      const match = rawData.find(r => r[xDim] === xVal && r[seriesDim] === sv);
      row[String(sv)] = match ? match[measure] : 0;
    });
    return row;
  });
  return { data: pivoted, xDim, seriesDim, seriesKeys: seriesVals.map(String) };
}

export const ROLE_PROMPTS = {
  analyst: [
    'What are the top performing segments this quarter?',
    'Show revenue trend by region',
    'Which products have the highest growth rate?',
    'Compare customer retention across segments',
    'Find unusual patterns in recent transactions',
    'What drives revenue the most?',
  ],
  finance: [
    'Show revenue vs cost by quarter',
    'What is the expense ratio trend?',
    'Compare revenue growth year over year',
    'Which segments are most profitable?',
    'Show cash flow by business unit',
    'What changed in collections last month?',
  ],
  operations: [
    'Show order count trend by month',
    'What is the average processing time?',
    'Compare operational metrics across regions',
    'Find bottlenecks in the workflow',
    'Show efficiency metrics by department',
    'What changed in throughput last quarter?',
  ],
  executive: [
    'Give me a summary of key metrics this quarter',
    'Which areas need attention right now?',
    'Compare this quarter to the same period last year',
    'What are the top 5 risks to watch?',
    'Show the performance scorecard by division',
    'What drove the biggest changes recently?',
  ],
  default: [
    'What are the key trends this quarter?',
    'Show the top metrics by category',
    'What changed compared to last period?',
    'Compare performance across segments',
    'Find unusual shifts in the data',
    'What drives this metric the most?',
  ],
};
